export const VARIANTS = ['base', 'list', 'listActive'];
